(function () {
  'use strict';

  if (window.HauberCustomerPrivacyEmbeds) {
    window.HauberCustomerPrivacyEmbeds.sync();
    return;
  }

  var allowedGoogleMapsHosts = [
    ['www', 'google', 'com'].join('.'),
    ['maps', 'google', 'com'].join('.')
  ];
  var customerPrivacyState = 'idle';
  var customerPrivacyCallbacks = [];
  var pendingInteractiveTrigger = null;
  var consentRequestPending = false;

  function isAllowedGoogleMapsUrl(value) {
    try {
      var url = new URL(value, window.location.href);

      return url.protocol === 'https:'
        && allowedGoogleMapsHosts.indexOf(url.hostname.toLowerCase()) !== -1
        && (url.pathname === '/maps/embed' || url.pathname.indexOf('/maps/embed/') === 0);
    } catch (error) {
      return false;
    }
  }

  function getCustomerPrivacy() {
    if (
      !window.Shopify
      || !window.Shopify.customerPrivacy
      || typeof window.Shopify.customerPrivacy.marketingAllowed !== 'function'
      || typeof window.Shopify.customerPrivacy.setTrackingConsent !== 'function'
    ) {
      return null;
    }

    return window.Shopify.customerPrivacy;
  }

  function finishCustomerPrivacyLoad(error) {
    var callbacks = customerPrivacyCallbacks.slice();
    var customerPrivacy = error ? null : getCustomerPrivacy();

    customerPrivacyCallbacks = [];
    customerPrivacyState = error || !customerPrivacy ? 'failed' : 'ready';
    callbacks.forEach(function (callback) {
      callback(error || (!customerPrivacy ? new Error('Customer Privacy API unavailable') : null), customerPrivacy);
    });
  }

  function withCustomerPrivacy(callback) {
    var customerPrivacy = getCustomerPrivacy();

    if (customerPrivacy) {
      customerPrivacyState = 'ready';
      callback(null, customerPrivacy);
      return;
    }

    customerPrivacyCallbacks.push(callback);
    if (customerPrivacyState === 'loading') {
      return;
    }
    if (customerPrivacyState === 'failed') {
      customerPrivacyState = 'idle';
    }
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
      finishCustomerPrivacyLoad(new Error('Shopify feature loader unavailable'));
      return;
    }

    customerPrivacyState = 'loading';
    window.Shopify.loadFeatures([
      {
        name: 'consent-tracking-api',
        version: '0.1'
      }
    ], function (error) {
      finishCustomerPrivacyLoad(error);
    });
  }

  function marketingAllowed(customerPrivacy) {
    try {
      return Boolean(customerPrivacy && customerPrivacy.marketingAllowed());
    } catch (error) {
      return false;
    }
  }

  function getEmbedContainer(trigger) {
    return trigger && trigger.closest('[data-customer-privacy-embed]');
  }

  function getMessageHost(container) {
    return container && (
      container.querySelector('.customer-privacy-embed__content')
      || container.querySelector('.customer-privacy-video__notice')
      || container
    );
  }

  function clearError(container) {
    var error = container && container.querySelector('[data-customer-privacy-embed-error]');

    if (error) {
      error.remove();
    }
    if (container) {
      container.removeAttribute('data-customer-privacy-embed-error-state');
    }
  }

  function showError(container, attributeName) {
    var message = container && container.getAttribute(attributeName || 'data-error-message');
    var messageHost = getMessageHost(container);

    if (!message || !messageHost) {
      return;
    }

    clearError(container);
    container.setAttribute('data-customer-privacy-embed-error-state', 'true');
    var errorElementName = messageHost.classList.contains('customer-privacy-video__notice') ? 'span' : 'p';
    var error = document.createElement(errorElementName);
    error.setAttribute('role', 'alert');
    error.setAttribute('data-customer-privacy-embed-error', '');
    error.className = 'customer-privacy-embed__error';
    error.textContent = message;
    messageHost.appendChild(error);
  }

  function focusFrame(frame) {
    window.requestAnimationFrame(function () {
      try {
        frame.focus({preventScroll: true});
      } catch (error) {
        frame.focus();
      }
    });
  }

  function loadMap(trigger, interactive) {
    var container = getEmbedContainer(trigger);
    var template = container && container.querySelector('[data-customer-privacy-embed-template]');
    var sourceFrame = template && template.content.querySelector('iframe');
    var source = sourceFrame && sourceFrame.getAttribute('src');

    if (!container || container.hasAttribute('data-customer-privacy-embed-loaded')) {
      return;
    }
    if (!sourceFrame || !source || !isAllowedGoogleMapsUrl(source)) {
      showError(container, 'data-error-message');
      return;
    }

    var frame = document.createElement('iframe');
    var originalContents = document.createDocumentFragment();
    while (container.firstChild) {
      originalContents.appendChild(container.firstChild);
    }

    frame.setAttribute('src', new URL(source, window.location.href).href);
    frame.setAttribute('title', trigger.getAttribute('data-frame-title') || '');
    frame.setAttribute('loading', 'lazy');
    frame.setAttribute('referrerpolicy', 'no-referrer');
    frame.setAttribute('allowfullscreen', '');
    frame.setAttribute('tabindex', '0');
    frame.setAttribute('data-customer-privacy-managed-map', '');

    container.__hauberPrivacyOriginalContents = originalContents;
    container.setAttribute('data-customer-privacy-embed-loaded', 'true');
    container.appendChild(frame);
    if (interactive) {
      focusFrame(frame);
    }
  }

  function getVideoUrl(trigger) {
    var videoId = trigger.getAttribute('data-youtube') || trigger.getAttribute('data-vimeo');

    if (!videoId || !/^[A-Za-z0-9_-]+$/.test(videoId)) {
      return '';
    }
    if (trigger.hasAttribute('data-youtube')) {
      return 'https://www.youtube-nocookie.com/embed/' + videoId + '?rel=0';
    }
    if (trigger.hasAttribute('data-vimeo') && /^\d+$/.test(videoId)) {
      return 'https://player.vimeo.com/video/' + videoId + '?dnt=1';
    }

    return '';
  }

  function loadVideo(trigger, interactive) {
    var container = getEmbedContainer(trigger);
    var videoUrl = container && getVideoUrl(container);

    if (!container || container.hasAttribute('data-customer-privacy-embed-loaded')) {
      return;
    }
    if (!videoUrl) {
      showError(container, 'data-error-message');
      return;
    }

    var frame = document.createElement('iframe');
    frame.className = 'iframe-playing';
    frame.setAttribute('src', videoUrl);
    frame.setAttribute('title', container.getAttribute('data-frame-title') || '');
    frame.setAttribute('loading', 'lazy');
    frame.setAttribute('referrerpolicy', 'no-referrer');
    frame.setAttribute('allow', 'accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
    frame.setAttribute('allowfullscreen', '');
    frame.setAttribute('tabindex', '0');
    frame.setAttribute('data-customer-privacy-managed-video', '');
    frame.__hauberPrivacyOriginalTrigger = container;

    clearError(container);
    container.setAttribute('data-customer-privacy-embed-loaded', 'true');
    container.replaceWith(frame);
    if (interactive) {
      focusFrame(frame);
    }
  }

  function loadEmbed(trigger, interactive) {
    var container = getEmbedContainer(trigger);
    var embedType = container && container.getAttribute('data-customer-privacy-embed');

    if (embedType === 'google-maps') {
      loadMap(trigger, interactive);
    } else if (embedType === 'external-video') {
      loadVideo(trigger, interactive);
    }
  }

  function loadAllowedEmbeds(interactiveTrigger) {
    var containers = document.querySelectorAll('[data-customer-privacy-embed]');

    Array.from(containers).forEach(function (container) {
      var trigger = container.matches('[data-customer-privacy-embed-load]')
        ? container
        : container.querySelector('[data-customer-privacy-embed-load]');

      if (trigger) {
        loadEmbed(trigger, trigger === interactiveTrigger);
      }
    });
  }

  function finishConsentRequest() {
    pendingInteractiveTrigger = null;
    consentRequestPending = false;
  }

  function unloadBlockedEmbeds() {
    Array.from(document.querySelectorAll('[data-customer-privacy-managed-map]')).forEach(function (frame) {
      var container = frame.closest('[data-customer-privacy-embed="google-maps"]');
      var originalContents = container && container.__hauberPrivacyOriginalContents;

      if (!container || !originalContents) {
        return;
      }

      frame.remove();
      container.removeAttribute('data-customer-privacy-embed-loaded');
      container.appendChild(originalContents);
      container.__hauberPrivacyOriginalContents = null;
    });

    Array.from(document.querySelectorAll('[data-customer-privacy-managed-video]')).forEach(function (frame) {
      var originalTrigger = frame.__hauberPrivacyOriginalTrigger;

      if (!originalTrigger) {
        return;
      }

      originalTrigger.removeAttribute('data-customer-privacy-embed-loaded');
      frame.replaceWith(originalTrigger);
    });
  }

  function syncConsentState() {
    withCustomerPrivacy(function (error, customerPrivacy) {
      if (error) {
        return;
      }

      if (marketingAllowed(customerPrivacy)) {
        loadAllowedEmbeds(pendingInteractiveTrigger);
        finishConsentRequest();
      } else {
        unloadBlockedEmbeds();
        if (!consentRequestPending) {
          pendingInteractiveTrigger = null;
        }
      }
    });
  }

  function requestMarketingConsent(trigger) {
    if (consentRequestPending) {
      return;
    }

    consentRequestPending = true;
    pendingInteractiveTrigger = trigger;
    withCustomerPrivacy(function (error, customerPrivacy) {
      var container = getEmbedContainer(trigger);

      if (error || !customerPrivacy || typeof customerPrivacy.setTrackingConsent !== 'function') {
        showError(container, 'data-consent-error-message');
        finishConsentRequest();
        return;
      }
      if (marketingAllowed(customerPrivacy)) {
        loadAllowedEmbeds(pendingInteractiveTrigger);
        finishConsentRequest();
        return;
      }

      clearError(container);
      customerPrivacy.setTrackingConsent({marketing: true}, function () {
        if (marketingAllowed(customerPrivacy)) {
          loadAllowedEmbeds(pendingInteractiveTrigger);
        } else {
          showError(container, 'data-consent-error-message');
        }
        finishConsentRequest();
      });
    });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-customer-privacy-embed-load]');

    if (!trigger) {
      return;
    }

    event.preventDefault();
    requestMarketingConsent(trigger);
  });

  document.addEventListener('visitorConsentCollected', syncConsentState);
  document.addEventListener('shopify:section:load', syncConsentState);

  window.HauberCustomerPrivacyEmbeds = {
    load: requestMarketingConsent,
    sync: syncConsentState
  };

  syncConsentState();
})();
